import script from "./LeaveBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaveBalance.vue?vue&type=script&setup=true&lang=js"

import "./LeaveBalance.vue?vue&type=style&index=0&id=84226c9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84226c9c"]])

export default __exports__